module.exports = __webpack_public_path__ + "static/media/4.f0f075e1.jpg";